// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.whiteboard-custom-ui.zoom-actions {
  position: absolute;
  bottom: 2;
  left: 2;
  z-index: 500;
  gap: 2px;

  display: flex;
}

.whiteboard-custom-ui.zoom-actions .zoom-in-out-button {
  height: 24px;
  width: 24px;
  border: none;
  border-radius: 10%;
  background-color: rgba(255, 255, 255, 0.4);
  color: black;
  transition: all 0.2s ease; /* Smooth transition for hover effects */
}

.whiteboard-custom-ui.zoom-actions .zoom-in-out-button svg,
.whiteboard-custom-ui.zoom-actions .zoom-in-out-button img {
  height: 100%;
  width: 100%;
}

.whiteboard-custom-ui.zoom-actions .zoom-middle-button {
  padding: 0;
  height: 24px;
  width: 48px;
  border: none;
  background-color: rgba(255, 255, 255, 0.4);
  color: black;
  transition: all 0.2s ease; /* Smooth transition for hover effects */
}

.whiteboard-custom-ui.zoom-actions .zoom-in-out-button:hover,
.whiteboard-custom-ui.zoom-actions .zoom-middle-button:hover {
  background-color: rgba(0, 0, 0, 0.1); /* Light gray background on hover */
  cursor: pointer; /* Change cursor to pointer */
}
.whiteboard-custom-ui.zoom-actions .zoom-in-out-button:active,
.whiteboard-custom-ui.zoom-actions .zoom-middle-button:active {
  transform: scale(0.98); /* Slight press effect */
}

.whiteboard-custom-ui.zoom-actions {
  position: absolute;
  bottom: 2px;
  left: 2px;
  z-index: 500;
  gap: 2px;

  display: flex;
  transition: all 0.3s ease;
}

/* Responsive: debajo de la toolbar, relativo al contenedor */
@media (max-height: 500px) {
  .whiteboard-custom-ui.zoom-actions {
    left: 4px;
    bottom: 0;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./react/features/whiteboard/custom-ui/styles/zoom-actions.css"],"names":[],"mappings":";;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,YAAY;EACZ,QAAQ;;EAER,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,yBAAyB,EAAE,wCAAwC;AACrE;;AAEA;;EAEE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,YAAY;EACZ,yBAAyB,EAAE,wCAAwC;AACrE;;AAEA;;EAEE,oCAAoC,EAAE,mCAAmC;EACzE,eAAe,EAAE,6BAA6B;AAChD;AACA;;EAEE,sBAAsB,EAAE,wBAAwB;AAClD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,QAAQ;;EAER,aAAa;EACb,yBAAyB;AAC3B;;AAEA,6DAA6D;AAC7D;EACE;IACE,SAAS;IACT,SAAS;IACT,eAAe;IACf,2BAA2B;EAC7B;AACF","sourcesContent":["\n\n.whiteboard-custom-ui.zoom-actions {\n  position: absolute;\n  bottom: 2;\n  left: 2;\n  z-index: 500;\n  gap: 2px;\n\n  display: flex;\n}\n\n.whiteboard-custom-ui.zoom-actions .zoom-in-out-button {\n  height: 24px;\n  width: 24px;\n  border: none;\n  border-radius: 10%;\n  background-color: rgba(255, 255, 255, 0.4);\n  color: black;\n  transition: all 0.2s ease; /* Smooth transition for hover effects */\n}\n\n.whiteboard-custom-ui.zoom-actions .zoom-in-out-button svg,\n.whiteboard-custom-ui.zoom-actions .zoom-in-out-button img {\n  height: 100%;\n  width: 100%;\n}\n\n.whiteboard-custom-ui.zoom-actions .zoom-middle-button {\n  padding: 0;\n  height: 24px;\n  width: 48px;\n  border: none;\n  background-color: rgba(255, 255, 255, 0.4);\n  color: black;\n  transition: all 0.2s ease; /* Smooth transition for hover effects */\n}\n\n.whiteboard-custom-ui.zoom-actions .zoom-in-out-button:hover,\n.whiteboard-custom-ui.zoom-actions .zoom-middle-button:hover {\n  background-color: rgba(0, 0, 0, 0.1); /* Light gray background on hover */\n  cursor: pointer; /* Change cursor to pointer */\n}\n.whiteboard-custom-ui.zoom-actions .zoom-in-out-button:active,\n.whiteboard-custom-ui.zoom-actions .zoom-middle-button:active {\n  transform: scale(0.98); /* Slight press effect */\n}\n\n.whiteboard-custom-ui.zoom-actions {\n  position: absolute;\n  bottom: 2px;\n  left: 2px;\n  z-index: 500;\n  gap: 2px;\n\n  display: flex;\n  transition: all 0.3s ease;\n}\n\n/* Responsive: debajo de la toolbar, relativo al contenedor */\n@media (max-height: 500px) {\n  .whiteboard-custom-ui.zoom-actions {\n    left: 4px;\n    bottom: 0;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
